export default __webpack_public_path__ + "static/media/GDP.62b2df9d.png";